import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { Sidebar } from '../../core/services/sidebar';
import { DownloadStatement } from "./download-statement/download-statement";
import { StatusScreenComponent } from "../../shared/components/status-screen-component/status-screen-component";
import { Button } from "../../shared/ui/button/button";
import { getInitials } from '../../shared/utils/functions';
import { Search } from "../../shared/components/search/search";

@Component({
  selector: 'app-transactions',
  imports: [CommonModule, DownloadStatement, TranslatePipe, StatusScreenComponent, Button, Search],
  templateUrl: './transactions.html',
  styleUrl: './transactions.css'
})
export class Transactions {
  activeTab: 'all' | 'cliq' | 'bankTransfer' | 'bills' = 'all';
  showStatusScreen: boolean = false;
  getInitials = getInitials;

  tabs = [
    { label: 'All', id: 'all' },
    { label: 'CliQ', id: 'cliq' },
    { label: 'Bank Transfer', id: 'bankTransfer' },
    { label: 'Bills', id: 'bills' },
  ];
  transactionGroups = [
    {
      dateLabel: "Today",
      date: "2025-10-14", // optional
      transactions: [
        {
          initials: "MA",
          title: "Madfooat",
          time: "4:35 PM",
          amount: 60.000,
          currency: "JOD",
          type: "outflow"
        },
        {
          initials: "ZA",
          title: "Zayn Ahmad",
          time: "3:20 PM",
          amount: 12.000,
          currency: "JOD",
          type: "inflow"
        },
        {
          initials: "AS",
          title: "App store",
          time: "2:15 PM",
          amount: 4.540,
          currency: "JOD",
          type: "inflow"
        }
      ]
    },
    {
      dateLabel: "9 Sep 2025",
      date: "2025-09-09",
      transactions: [
        {
          initials: "MA",
          title: "Madfooat",
          time: "4:35 PM",
          amount: 60.000,
          currency: "JOD",
          type: "outflow"
        },
        {
          initials: "ZA",
          title: "Zayn Ahmad",
          time: "3:20 PM",
          amount: 12.000,
          currency: "JOD"
        }
      ]
    },
    {
      dateLabel: "9 Sep 2025",
      date: "2025-09-09",
      transactions: [
        {
          initials: "MA",
          title: "Madfooat",
          time: "4:35 PM",
          amount: 60.000,
          currency: "JOD",
          type: "outflow"
        },
        {
          initials: "ZA",
          title: "Zayn Ahmad",
          time: "3:20 PM",
          amount: 12.000,
          currency: "JOD"
        }
      ]
    },
    {
      dateLabel: "9 Sep 2025",
      date: "2025-09-09",
      transactions: [
        {
          initials: "MA",
          title: "Madfooat",
          time: "4:35 PM",
          amount: 60.000,
          currency: "JOD",
          type: "outflow"
        },
        {
          initials: "ZA",
          title: "Zayn Ahmad",
          time: "3:20 PM",
          amount: 12.000,
          currency: "JOD"
        }
      ]
    }
  ];
  currentTransactionView: any = null;

  constructor(
    private sidebarService: Sidebar,
  ) { }

  ngOnInit() {
    this.sidebarService.setToDefault();
  }

  changeActiveTab(tab: any) {
    this.activeTab = tab;
  }

  viewTransactionDetails(transaction: any) {
    this.showStatusScreen = true;
    this.currentTransactionView = transaction;
  }

  backToTransactions() {
    this.showStatusScreen = false;
  }

  downloadReceipt() {
    //todo: handle api or download
    this.showStatusScreen = false;
  }

  onSearchChange(value: string) {
    const search = value.toLowerCase().trim();

    //implement searching here
  }
}
